import { makeStyles } from '@material-ui/core/styles';
import { Colors } from 'utils';
import { SendRemittanceDocument } from './sendRemittanceDocument';

export const paymentVerificationDetailsStyle = makeStyles(() => ({
  itemsSection: {
    display: 'flex',
    width: '100%',
    marginTop: '24px',
  },
  warnWrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#FFF6EA 0% 0% no-repeat padding-box',
    borderRadius: '8px',
    padding: '10px 16px',
    marginTop: '24px',
    fontSize: '14px',
    '& img': {
      marginRight: '8px',
    },
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    color: Colors.TextPrimary,
  },
  requestCorrection: {
    width: '238px',
    height: '48px',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '2px solid #438AFE',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    color: Colors.ThemeBlue,
  },
  pastTable: {
    marginLeft: '50px',
  },
  pmtButtonsWrapper: {
    display: 'flex',
    marginTop: '24px',
    marginBottom: '20px',
  },

  sendCarrierEmailWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    padding: '0 16px',
    borderRadius: '4px',
    background: '#F7F9FC',
    marginLeft: 'auto',
  },

  sendCarrierEmailImg: {
    width: '24px',
    height: '24px',
    padding: '3px',
    background: '#E8EAF6',

    '& img': {
      width: '100%',
      height: '100%',
    },
  },

  sendCarrierEmailText: {
    color: '#000',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },

  sendCarrierReEmailButton: {
    border: 'none',
    background: 'none',
    padding: '9px 15px',
    color: '#438BFE',
    textAlign: 'right',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
    whiteSpace: 'nowrap',
  },

  sendRemittanceDocumentWrapper: {
    width: '424px',
  },
}));